import React from 'react';
import { SfcShellAppBarIcon } from '@waypoint/react-components';
import { SHELL_NAV_ICON } from '../../constants';
import languageTranslation from '../../common/languageTranslation';

export default function FeedbackIcon() {
  return (
    <SfcShellAppBarIcon
      slot="icons"
      icon="action-chat"
      className={`${SHELL_NAV_ICON} md:mr-4`}
      label={languageTranslation('common.feedback')}
      href="javascript:void(0)"
      onClick={() => {
      }}
    />
  );
}
